<header>
    <h2>Module</h2>
    <h5>New Module</h5>
</header>
<div class="content-body">
    <div class="input-div name-input">
        <label for="new-module-name">Name</label>
        <input [(ngModel)]="name" id="new-module-name" type="text" />
    </div>
    <div class="input-div desc-input">
        <label for="description">Description</label>
        <textarea [(ngModel)]="description" id="description" type="text"></textarea>
        <span class="hint">Hint: A suitable tagline to describe the module</span>
    </div>
    <div class="icon-picker-container">
      <h4>Icon</h4>
      <div class="icon-picker" data-bs-toggle="modal" data-bs-target="#iconModal">
        <ng-container *ngIf="icon == null && iconPath == null">  
          <h5 class="picker-title">Chose a icon or import it here.</h5>
          <p>Only vector format supported.</p>
        </ng-container>
        <ng-container *ngIf="icon != null || iconPath != null">
          <p class="placeholder-icon">{{ icon ? icon.name : iconPath }}</p>
        </ng-container>
      </div>
    </div>
    <div class="color-palete-container">
        <h3 class="title">Color</h3>
        <div class="color-palete d-flex">
            <div class="color-circle" *ngFor="let colorCircle of circleColors; let i = index" [style.background-color]="circleColors[i]" (click)="selectColorCircle(colorCircle, i)">
              <svg *ngIf="color == colorCircle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="16" height="16" fill="none">
                <path d="M20 52 L40 72 L80 28" stroke="#ffffff" stroke-width="14" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <button type="button" data-bs-toggle="modal" data-bs-target="#colorModal">More</button>
        </div>
    </div>
    <app-custom-file-input [svgOnly]="false" (imgFile)="handleImgFile($event)"></app-custom-file-input>
    <div class="footer d-flex justify-content-between px-0">
        <button class="cancel-btn">Cancel</button>
        <button class="save-btn" (click)="onSave()">Save</button>
    </div>
</div>

<div class="modal fade" id="colorModal" tabindex="-1" aria-labelledby="colorModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="wf-modal-header modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="wf-modal-body modal-body d-flex gap-4 justify-content-center align-items-center">
        <div class="color-modal-top">
          <span>Color</span>
        </div>
        <color-sketch
            [color]="color"
            (onChangeComplete)="onColorChange($event)">
        </color-sketch>
      </div>
      <div class="wf-modal-footer modal-footer">
        <button type="button" class="btn btn-dark" data-bs-dismiss="modal">
          Add
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="iconModal" tabindex="-1" aria-labelledby="iconModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="wf-modal-header modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="wf-modal-body modal-body d-flex gap-4 justify-content-center align-items-center">
        <app-icon-modal-content (svgFile)="handleSvgFile($event)" (svgFilePath)="handleSvgFile($event)" ></app-icon-modal-content>
      </div>
      <div class="wf-modal-footer modal-footer">
        <button type="button" class="btn btn-dark" data-bs-dismiss="modal">
          Add
        </button>
      </div>
    </div>
  </div>
</div>
